export default {
  emailNote:
    "Your email is only used to send you a gift receipt and is not shared with anyone.",
  giftDetails: "GIFT SUBSCRIPTION DETAILS",
  giftSubscriptionLength: "Gift Subscription Length",
  gifterEmail: "Your Email",
  gifterName: "Your Name",
  introNote: (siteName: string): string =>
    `Give the ultimate gift - a subscription to ${siteName.replace(
      ".com",
      ""
    )}! There is no better place for a college sports recruiting fan to feel like an insider. If they’re already part of the ${siteName.replace(
      ".com",
      ""
    )} family, your gift will act as an extension! With breaking team news & community discussions happening year-round, make sure they don’t miss a thing.`,
  personalizedMessage: "Send a personalized message",
  recipientEmail: "Recipient's Email",
  recipientName: "Recipient's Name",
  selectSite: "Choose a Site in the Rivals Network",
  selectSitePlaceholder: "Select a site"
};
